/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, {useContext} from "react";
import Context from "../context";
import { convertDateToUKFormat } from "../../../utils";

const Info = () => {
    const context = useContext(Context);

    return(
        <div className="card  mb-4">
            <div className="card-header pb-0 p-3">
                <div className="row">
                    <div className="col-md-8 d-flex align-items-center">
                        <h5 className="mb-0">PROFILE INFORMATION</h5>
                    </div>
                </div>
            </div>
            <div className="card-body p-3">
                <ul className="list-group mt-4">
                    {[
                        {
                            name: "Id",
                            value: context.state.details.admin_id,
                        },
                        {
                            name: "Full name",
                            value: context.state.details.admin_full_name,
                        },
                        {
                            name: "Contact number",
                            value: context.state.details.admin_contact_number,
                        },
                        {
                            name: "Email",
                            value: context.state.details.admin_email,
                        },
                        {
                            name: "created",
                            value: convertDateToUKFormat(context.state.details.admin_createdAt),
                        },
                        {
                            name: "Status",
                            value: context.state.details.admin_status === "Verify" ? "VERIFIED" : "UNVERIFIED",
                        },
                    ].map((item, index) => (
                        <li className="list-group-item border-0 ps-0 pt-0 text-sm" key={index}>
                            <strong className="text-dark">{item.name}:</strong> &nbsp; {item.value}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default Info;